import { render, staticRenderFns } from "./dr-snippet.vue?vue&type=template&id=5cf3a161"
import script from "./dr-snippet.vue?vue&type=script&lang=js"
export * from "./dr-snippet.vue?vue&type=script&lang=js"
import style0 from "./dr-snippet.vue?vue&type=style&index=0&id=5cf3a161&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports